import {
  BsFacebook,
  BsInstagram,
  BsTwitter,
  BsYoutube,
  BsTelegram,
} from "react-icons/bs";
import { TbWorldWww } from "react-icons/tb";
import { GrMail } from "react-icons/gr";
import { ImWhatsapp } from "react-icons/im";
import { FaMapMarkerAlt } from "react-icons/fa";

export const links = [
  {
    title: "Website",
    href: "https://www.cciahn.com",
    icon: TbWorldWww,
  },
  {
    title: "Correo electrónico",
    href: "mailto:oficina@cciahn.org?subject=Consulta web",
    icon: GrMail,
  },
  {
    title: "Facebook",
    href: "https://www.facebook.com/CCIA1936",
    icon: BsFacebook,
  },
  {
    title: "Instagram",
    href: "https://www.instagram.com/cciahn",
    icon: BsInstagram,
  },
  {
    title: "Twitter",
    href: "https://www.twitter.com/CCIA_0101",
    icon: BsTwitter,
  },
  {
    title: "WhatsApp",
    href: "https://wa.me/50494488096",
    icon: ImWhatsapp,
  },
  {
    title: "Telegram",
    href: "https://t.me/cciahn",
    icon: BsTelegram,
  },
  {
    title: "YouTube",
    href: "https://youtube.com/@cciahn",
    icon: BsYoutube,
  },
  {
    title:
      "Residencial La Florida, entrada a la Escuela Bilingüe Brassavola, contiguo a Ciudad Mujer, 31101, La Ceiba, Honduras",
    href: "https://goo.gl/maps/tgercABAuCf6bX38A",
    icon: FaMapMarkerAlt,
  },
];
